interface ReasoningListProps {
  reasoning: string[]
}

export function ReasoningList({ reasoning }: ReasoningListProps) {
  if (reasoning.length === 0) return null
  return (
    <div className="space-y-1" data-testid="reasoning-list">
      <h4 className="text-sm font-semibold text-slate-700">Begründung</h4>
      <ul className="list-disc list-inside text-sm text-slate-700 space-y-0.5">
        {reasoning.map((line, idx) => (
          <li key={idx}>{line}</li>
        ))}
      </ul>
    </div>
  )
}
